module.exports = __webpack_public_path__ + "img/bul_feature02_active.8b954114.svg";